import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { TypographyProps } from '@mui/material/Typography';
import MaterialUITypography from './Typography';

const subtitlePropertyTypes = {
  children: PropTypes.node,
  tag: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
};

type SubtitleProperties =
  InferProps<typeof subtitlePropertyTypes>;

const Subtitle = ({
  children, tag, className, variant,
}: SubtitleProperties) => (
  <MaterialUITypography
    tag={(tag ?? 'span') as Component.Tag}
    className={className ?? undefined}
    variant={
      (variant ?? 'subtitle1') as
        TypographyProps['variant']
    }
    color="textSecondary"
  >
    {children}
  </MaterialUITypography>
);

Subtitle.propTypes = subtitlePropertyTypes;

export default Subtitle;
